import React from "react";
import { Dialog, DialogProps, ModalProps } from "@material-ui/core";

export interface CustomDialogProps extends Omit<DialogProps, "open"> {
  open?: ModalProps["open"];
}

/**
 * Customised version of the MUI Dialog used for most GCUI Dialogs.
 * Clicking the backdrop to close the dialog is disabled.
 * @param children - Contents of the dialog
 * @param open
 * @param other
 * @constructor
 */
export const CustomDialog: React.FC<CustomDialogProps> = ({
  children,
  open = true,
  ...other
}) => {
  const defaults: Partial<DialogProps> = {
    fullWidth: true,
    maxWidth: "sm",
    disableBackdropClick: true,
  };

  return (
    <Dialog open={!!open} {...defaults} {...other}>
      {children}
    </Dialog>
  );
};
